<template>
  <a-modal
    title="指定货品质量"
    :visible="visible"
    :width="520"
    class="bath-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :form="formData" v-bind="layout" layout="inline">
      <a-row>
        <a-col :span="16">
          <a-form-model-item label="选择货品质量">
            <a-select
              v-model="formData.designatedGoodsQuality"
              :get-popup-container="(triggerNode) => (triggerNode.parentElement)"
              allow-clear
              placeholder="请选择指定货品质量"
            >
              <a-select-option
                v-for="item in goodsQuality"
                :key="item.value"
                :value="item.value"
              >{{item.label}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'Quality',
  props: {
    goodsQuality: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      chooseIndex: null,
      formData: {},
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },
    }
  },
  methods: {
    show(index, row) {
      this.visible = true;
      this.formData = {...row};
      this.chooseIndex = index
    },
    handleOk() {
      this.$emit('changeQuality', this.chooseIndex, this.formData);
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false;
    },
  }
}
</script>

<style lang="less" scoped>
  .bath-modal {
    .ant-form-item {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
    }
  }
  </style>